/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { PatternTypes } from "../mappers/banners.constants";

export class LocalizedDateUtility {
  private readonly timeZoneOffset = new Date().getTimezoneOffset() * -60000;

  transform(value: any, pattern: PatternTypes = "medium"): any {
    return this.formatDate(this.getDateInMillisecondsUtc(value), pattern);
  }

  private getDateInMillisecondsUtc(date: any) {
    return new Date(date).getTime() + this.timeZoneOffset;
  }

  private formatDate(date: number, format: PatternTypes): string {
    const formattedDate = new Date(date).toLocaleDateString(undefined, {
      dateStyle: format,
    });
    return formattedDate;
  }
}
